module.exports = __webpack_public_path__ + "img/ground-mountain.b35668a8.png";